<script lang="ts" setup>
import { useAuthStore } from '@/app/store/authStore';
import { useToast } from 'ah-common-lib/src/toast/Toast';
import { VButton } from 'ah-common-lib/src/common/components';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import IntegrationsTestComponent from '@/app/components/integrations/IntegrationsTestComponent.vue';

const appVersion = window.VUE_APP_VERSION;

const commitHash = window.VUE_APP_COMMIT_HASH;

const authStore = useAuthStore();

const toast = useToast();

const requestManager = useRequestManager().manager;

function invalidateSession() {
  authStore.authToken = 'INVALID';
  toast.success('Session invalidated');
}

function invalidateRefreshToken() {
  authStore.refreshToken = 'INVALID';
  toast.success('Refresh token invalidated');
}

function refreshSession() {
  requestManager.sameOrNewPromise(
    'refreshSession',
    () =>
      authStore.refreshSession().then(() => {
        authStore.isLoggedIn ? toast.success('Session refreshed') : toast.error('Session in error, logged out user');
      }),
    authStore.authToken
  );
}
</script>
<template>
  <div class="padded-space" id="dev-settings-view">
    <div class="centered-space">
      <h2>Dev Settings</h2>
      <BoxGrid alignH="start">
        <BoxGridBlock cols="8" lg="8" md="6" sm="12" order-sm="1" order-md="0">
          <VButton class="mb-3 btn-stroked" @click="invalidateSession">Invalidate Session</VButton>
          <VButton class="mb-3 btn-stroked" @click="invalidateRefreshToken">Invalidate Refresh Token</VButton>
          <VButton
            class="mb-3"
            :loading="requestManager.requestStates.refreshSession === 'pending'"
            @click="refreshSession"
            >Refresh Session</VButton
          >
        </BoxGridBlock>
        <BoxGridBlock cols="4" lg="4" md="6" sm="12">
          <h3>App version</h3>
          <div class="versions">
            <DataRow label="Version" class="app-version">{{ appVersion }}</DataRow>
            <DataRow class="hash-row app-commit-hash" label="Commit Hash">{{ commitHash }}</DataRow>
          </div>
        </BoxGridBlock>
        <BoxGridBlock cols="12">
          <h3>Integrations</h3>
          <IntegrationsTestComponent />
        </BoxGridBlock>
      </BoxGrid>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.versions {
  @include themedTextColor($color-text-secondary);

  .hash-row {
    word-break: break-word;
  }
}
</style>
